module.exports = __webpack_public_path__ + "img/index-ld2.8e1268f8.png";